(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('risk-rule', {
            parent: 'entity',
            url: '/risk-rule?page&sort&search',
            data: {
                authorities: [/^ROLE_(ADMIN|LENDER).*/],
                pageTitle: 'valueconnectApp.riskRule.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/risk-rule/risk-rules.html',
                    controller: 'RiskRuleController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('riskRule');
                    $translatePartialLoader.addPart('appraisalOrder');
                    $translatePartialLoader.addPart('address');
                    $translatePartialLoader.addPart('formStandardResidential');
                    $translatePartialLoader.addPart('formStandardResidentialCuspap2024');
                    $translatePartialLoader.addPart('formCostApproach');
                    $translatePartialLoader.addPart('formCostApproachCuspap2024');
                    $translatePartialLoader.addPart('formIncomeApproach');
                    $translatePartialLoader.addPart('formIncomeApproachCuspap2024');
                    $translatePartialLoader.addPart('formDetrimentalConditions');
                    $translatePartialLoader.addPart('enum');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('risk-rule-detail', {
            parent: 'risk-rule',
            url: '/risk-rule/{id}',
            data: {
                authorities: [/^ROLE_(ADMIN|LENDER).*/],
                pageTitle: 'valueconnectApp.riskRule.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/risk-rule/risk-rule-detail.html',
                    controller: 'RiskRuleDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('riskRule');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RiskRule', function($stateParams, RiskRule) {
                    return RiskRule.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'risk-rule',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('risk-rule-detail.edit', {
            parent: 'risk-rule-detail',
            url: '/detail/edit',
            data: {
                authorities: [/^ROLE_(ADMIN|LENDER).*/]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/risk-rule/risk-rule-dialog.html',
                    controller: 'RiskRuleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RiskRule', function(RiskRule) {
                            return RiskRule.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('risk-rule.new', {
            parent: 'risk-rule',
            url: '/new',
            data: {
                authorities: [/^ROLE_(ADMIN|LENDER).*/]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/risk-rule/risk-rule-dialog.html',
                    controller: 'RiskRuleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                lenderReferenceId: null,
                                name: null,
                                description: null,
                                rule: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('risk-rule', null, { reload: 'risk-rule' });
                }, function() {
                    $state.go('risk-rule');
                });
            }]
        })
        .state('risk-rule.edit', {
            parent: 'risk-rule',
            url: '/{id}/edit',
            data: {
                authorities: [/^ROLE_(ADMIN|LENDER).*/]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/risk-rule/risk-rule-dialog.html',
                    controller: 'RiskRuleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RiskRule', function(RiskRule) {
                            return RiskRule.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('risk-rule', null, { reload: 'risk-rule' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('risk-rule.delete', {
            parent: 'risk-rule',
            url: '/{id}/delete',
            data: {
                authorities: [/^ROLE_(ADMIN|LENDER).*/]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/risk-rule/risk-rule-delete-dialog.html',
                    controller: 'RiskRuleDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RiskRule', function(RiskRule) {
                            return RiskRule.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('risk-rule', null, { reload: 'risk-rule' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
